import React, { useCallback } from 'react';
import userAgreement from './AsioEnablementDialog/UserAgreement';
import { formatMessage } from 'cw-ui-core';
import Locale from 'src/Locale';
import { Box, Checkbox, Typography } from '@mui/material';
import { Card } from '@cw-ui/surface-components';
import PropTypes from 'prop-types';

const UserAgreementCard = ({ onAgreementChange, isChecked }) => {
  const handleCheckboxChange = useCallback(
    event => onAgreementChange(event.target.checked),
    [onAgreementChange]
  );

  const renderAgreementContent = () =>
    userAgreement.map(({ heading, paragraph }) => (
      <div key={heading}>
        <Typography fontWeight="bold" fontSize={10}>
          {heading}
        </Typography>
        <Typography fontWeight={400} fontSize={10} whiteSpace="break-spaces">
          {paragraph}
        </Typography>
      </div>
    ));

  return (
    <Card
      variant="default"
      sx={{
        p: 2,
        mt: 1,
        backgroundColor: '#EDF5FF',
        width: 'calc(100% - 32px)',
        boxShadow: 'none',
        '&:hover': { backgroundColor: '#EDF5FF !important' }
      }}
    >
      <Typography fontWeight={600} mb={0.5} fontSize={12} color="#101120">
        {formatMessage(Locale.license_service_agreement)}
      </Typography>
      <Box sx={{ maxHeight: 120, overflowY: 'auto', width: '100%' }}>
        <Typography fontWeight={600} fontSize={10} color="#101120">
          {formatMessage(Locale.asio_service_agreement_title)}
        </Typography>
        <Typography fontWeight={600} fontSize={10} color="#101120" mt={1}>
          {formatMessage(Locale.asio_service_agreement_sub)}
        </Typography>
        <Typography fontSize={10} mt={1}>
          {formatMessage(Locale.asio_service_agreement_sub2)}
        </Typography>
        {renderAgreementContent()}
      </Box>
      <Box display="flex" alignItems="center" mt={1}>
        <Checkbox
          sx={{ ml: -1 }}
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        <Typography fontSize={12} fontFamily="Inter" fontWeight={400}>
          {formatMessage(Locale.service_agreement_sub)}
          <Typography
            component="span"
            color="#D32F2F"
            fontWeight={400}
            fontSize={12}
          >
            {formatMessage(Locale.service_agreement_sub2)}
          </Typography>
        </Typography>
      </Box>
    </Card>
  );
};

UserAgreementCard.propTypes = {
  onAgreementChange: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired
};

export default UserAgreementCard;
